import React from 'react'

function Education(props) {
    return (
        <div className='container-sm my-3'>
            <div className="row mb-5">
                <div className="col-md-6 col-lg-4" data-aos-duration="1200" data-aos="zoom-in" data-aos-delay="200">
                    <div className="card my-3" style={{ backgroundColor: props.BGColor === "#DEF2F1" ? "#17252A" : "#DEF2F1" }}>
                        <div className="card-header" style={{ backgroundColor: props.BGColor }}>
                            <div className="mt-2">
                                <h4 className={`text-${props.BGColor === "#17252A" ? "light" : "dark"}`}>Expertise</h4>
                                <span className="line" style={{ backgroundColor: props.color }}></span>
                            </div>
                        </div>
                        <div className={`card-body text-${props.BGColor === "#DEF2F1" ? "white-50" : "dark"}`}>
                            <h6 className="title" style={{ color: props.color === "#2B7A78" ? "#3AAFA9" : "#2B7A78" }}>2021 - Present</h6>
                            <p className='sub-title'>Front-End Designer</p>
                            <p className="subtitle">As a front-end designer, my ongoing journey has enabled me to continuously refine my craft, creating captivating and responsive web interfaces that bridge creativity with functionality</p>
                            <hr />
                            <h6 className="title" style={{ color: props.color === "#2B7A78" ? "#3AAFA9" : "#2B7A78" }}>2016 - 2017</h6>
                            <p className='sub-title'>Java Developer</p>
                            <p className="subtitle">As a Java developer, my ongoing journey has allowed me to continually refine my skills, crafting robust and efficient software solutions that blend innovation with functionality.</p>
                            <hr />
                            <h6 className="title" style={{ color: props.color === "#2B7A78" ? "#3AAFA9" : "#2B7A78" }}>2015 - 2016</h6>
                            <p className='sub-title'>MERN-Stack Developer</p>
                            <p className="subtitle">As a MERN stack developer, I've been on a continuous journey, refining my expertise in building dynamic web applications with MongoDB, Express.js, React, and Node.js. Crafting scalable and responsive solutions has been my passion and focus.</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4" data-aos-duration="1200" data-aos="zoom-in" data-aos-delay="200">
                    <div className="card my-3" style={{ backgroundColor: props.BGColor === "#DEF2F1" ? "#17252A" : "#DEF2F1" }}>
                        <div className="card-header" style={{ backgroundColor: props.BGColor }}>
                            <div className="mt-2">
                                <h4 className={`text-${props.BGColor === "#17252A" ? "light" : "dark"}`}>Education</h4>
                                <span className="line" style={{ backgroundColor: props.color }}></span>
                            </div>
                        </div>
                        <div className={`card-body text-${props.BGColor === "#DEF2F1" ? "white-50" : "dark"}`}>
                            <h6 className="title" style={{ color: props.color === "#2B7A78" ? "#3AAFA9" : "#2B7A78" }}>2021 - Present</h6>
                            <p className='sub-title'>B.Tech Computer Engineering</p>
                            <p className="subtitle">Pursuing a degree in Computer Engineering, I am dedicated to expanding my knowledge and skills in the field of technology and engineering, laying the foundation for a promising future.</p>
                            <hr />
                            <h6 className="title" style={{ color: props.color === "#2B7A78" ? "#3AAFA9" : "#2B7A78" }}>2019 - 2021</h6>
                            <p className='sub-title'>HSC in Electronics and Telecommunication</p>
                            <p className="subtitle">Holding an HSC degree in Electronics and Telecommunication Engineering (ENTC), I'm eager to further my education and expertise in this field.</p>
                            <hr />
                            <h6 className="title" style={{ color: props.color === "#2B7A78" ? "#3AAFA9" : "#2B7A78" }}>2018 - 2019</h6>
                            <p className='sub-title'>SSC from Shri N.T Mundada Global View School, Amalner</p>
                            <p className="subtitle">Completed my 10th grade education at Shri N.T. Mundada Global View School, marking an important milestone in my academic journey.</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4" style={{ zIndex: -1 }} data-aos-duration="1200" data-aos="zoom-in" data-aos-delay="200" >
                    <div className="card my-3" style={{ backgroundColor: props.BGColor === "#DEF2F1" ? "#17252A" : "#DEF2F1" }}>
                        <div className="card-header" style={{ backgroundColor: props.BGColor }}>
                            <div className="pull-left">
                                <h4 className={`mt-2 text-${props.BGColor === "#17252A" ? "light" : "dark"}`}>Skills</h4>
                                <span className="line" style={{ backgroundColor: props.color }}></span>
                            </div>
                        </div>
                        <div className={`card-body pb-2 text-${props.mode}`}>
                        <h6>C - Language</h6>
                            <div className="progress mb-3">
                                <div className="progress-bar bg-danger" role="progressbar" style={{ width: "100%" }}
                                    aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <h6>C++</h6>
                            <div className="progress mb-3">
                                <div className="progress-bar bg-danger" role="progressbar" style={{ width: "80%" }}
                                    aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <h6>Java</h6>
                            <div className="progress mb-3">
                                <div className="progress-bar bg-danger" role="progressbar" style={{ width: "70%" }}
                                    aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <h6>HTML5 &amp; CSS3</h6>
                            <div className="progress mb-3">
                                <div className="progress-bar bg-danger" role="progressbar" style={{ width: "100%" }}
                                    aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <h6>JavaScript</h6>
                            <div className="progress mb-3">
                                <div className="progress-bar bg-danger" role="progressbar" style={{ width: "80%" }}
                                    aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <h6>Python</h6>
                            <div className="progress mb-3">
                                <div className="progress-bar bg-danger" role="progressbar" style={{ width: "50%" }}
                                    aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <h6>SQL</h6>
                            <div className="progress mb-3">
                                <div className="progress-bar bg-danger" role="progressbar" style={{ width: "90%" }}
                                    aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <h6>Figma</h6>
                            <div className="progress mb-3">
                                <div className="progress-bar bg-danger" role="progressbar" style={{ width: "75%" }}
                                    aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <h6>MERN</h6>
                            <div className="progress mb-3">
                                <div className="progress-bar bg-danger" role="progressbar" style={{ width: "50%" }}
                                    aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Education
